import React, { Component } from "react";
import { Redirect } from 'react-router';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBIcon,
  //MDBInput,
  //MDBAnimation,
  MDBCard,
  MDBCardBody,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter
} from "mdbreact";
import SectionContainer from "./../components/sectionContainer";
import axios from 'axios';
import logo1 from './cambiar.png';

class FormsPage extends Component {
  /* INICAMOS LAS VARIABLES */  
    state = {      
      respuesta     : [],  
      usuario       : '',
      claveanterior : '',
      clavenuevo    : '',
      modal1        : false,
      modal2        : false,
      modal3        : false
    }

    /* SETEMOS LOS VALOREA ASIGNADOS */
    onChange(e){
      this.setState({
          [e.target.name]:e.target.value
      })
    }

    /* LO QUE SE EJECUTA AL ENVIAR LA SOLCITUD */
    acceder = async (event) =>{
      event.preventDefault();//SI HAY VALORES  VACIOS NO SE ENVIA
      await  axios.post('http://remuneraciones.unsaac.edu.pe:3001/cambiarpassword',{
        method      : 'post',
        credentials : 'same-origin',
        headers     : {//CABECERA DONDE INDICAMOS EL TIPO DE FORMATO A ENVIAR
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({//CUERPO EN FORMATO JSON, DONDE ENVIAREMOS LOS PARAMETROS
          usuario       : this.state.usuario,
          claveanterior : this.state.claveanterior,
          clavenuevo    : this.state.clavenuevo
       })
      })
      .then( async (response) => {
              await this.setState({ respuesta : response.data});
          })
      .catch(error =>{})  
        
      /* SI EXISTE ALGUNA RESPUESTA MOSTRAMOS LOS MODALES */    
      if(this.state.respuesta.length>0){
        //console.log(this.state.respuesta);
        //var ventanita = this.state.respuesta.ventana;
        //var output = JSON.parse(this.state.respuesta);
        //console.log(this.state.respuesta[0].modal1);

        if(this.state.respuesta[0].modal1==="true")
          this.setState({modal1 : true})
        if(this.state.respuesta[0].modal2==="true")
          this.setState({modal2 : true})   
      }

      /* DESPUES DE LA LLAMADA PASE LOS QUE PASE RESTAURAMOS LOS VALORES AL INICIAL */  
      this.setState({ usuario : ''})
      this.setState({ claveanterior : ''})
      this.setState({ clavenuevo : ''}) 
      //this.setState({ ventanita : true}) 
      //console.log(this.state.respuesta);       
    }

    //llamamos al a funcion tick
    tick() {
      window.location.reload();
    }
    
    toggle = nr => () => {
      let modalNumber = "modal" + nr;
      this.setState({
        [modalNumber]: !this.state[modalNumber]
      });
    }

  render() {
     return (
      <MDBContainer className="mt-4">
        <SectionContainer header="Cambiar contraseña" noBorder>
          {/**************************************************************************************/}
          {/**************************************************************************************/}
          {/*FORMULARIO DE CAMBIO DE CONTRASEÑA*/}
          <MDBRow>
            <MDBCol md="4">
              <SectionContainer>
                <form>
                  {/* <p className="h5 text-center mb-4">Modulo para cambiar contraseña</p> */}
                  <div className="grey-text">
                    <MDBInput
                      label     = "Ingrese su DNI"
                      icon      = "envelope"
                      group                      
                      validate
                      error     = "wrong"
                      success   =  "right"
                      value     = {this.state.usuario} 
                      onChange  = {this.onChange.bind(this)}
                      name      = "usuario" 
                      id        = "usuario" 
                      type      = "text"
                    />
                    <MDBInput
                      label     = "Contraseña anterior"
                      icon      = "envelope"
                      group                      
                      validate
                      error     = "wrong"
                      success   = "right"
                      value     = {this.state.claveanterior} 
                      onChange  = {this.onChange.bind(this)}
                      name      = "claveanterior" 
                      id        = "claveanterior" 
                      type      = "password"
                    />
                    <MDBInput 
                      label     = "Contraseña nueva" 
                      icon      = "lock" 
                      group                     
                      validate 
                      value     = {this.state.clavenuevo} 
                      onChange  = {this.onChange.bind(this)}
                      name      = "clavenuevo" 
                      id        = "clavenuevo" 
                      type      = "password"                      
                    />
                  </div>
                  <div className="text-center">
                    <MDBBtn onClick={this.acceder.bind(this)}>Cambiar Clave</MDBBtn>
                  </div>
                </form>
              </SectionContainer>
            </MDBCol>
            <MDBCol md="6">
              <div>
                <img src={logo1} width="200" height="200" />
              </div>
            </MDBCol>
          </MDBRow>
          {/**************************************************************************************/}
          {/**************************************************************************************/}
          {/*FIN FORMULARIO DE CAMBIO DE CONTRASEÑA*/}
          

          <MDBRow>
            <MDBCol md="4">
                <SectionContainer noBorder header="">
                  {/**************************************************************************************/}
                  {/*MODAL DE EXITO*/}
                  <MDBModal className="modal-notify modal-info text-white"  isOpen={this.state.modal1} toggle={this.toggle(1)} >
                    {/*CABECERA*/}
                      <MDBModalHeader className="text-center" titleClass="w-100" tag="p">INFORMACION</MDBModalHeader>
                    {/*FIN CABECERA*/}

                    {/*CUERPO*/}
                      <MDBModalBody className="text-center">
                        <MDBIcon icon="bell" size="4x" className="animated rotateIn mb-4"/>
                          {this.state.respuesta.map(select => (
                            <tr key={select.trabajador}>
                              <td>{select.informacion}</td>
                            </tr>
                          ))} 
                      </MDBModalBody>
                    {/*FIN CUERPO*/}

                    {/*PIE*/}
                      <MDBModalFooter className="justify-content-center">
                        <MDBBtn color="primary" onClick={this.toggle(1)}>
                          Salir
                        </MDBBtn>
                      </MDBModalFooter>
                    {/*FIN PIE*/}
                  </MDBModal>
                  {/**************************************************************************************/}
                  {/*FIN MODAL DE EXITO*/}


                  {/**************************************************************************************/}
                  {/*MODAL DE FRACASO*/}
                  <MDBModal
                    modalStyle="danger"
                    className="text-white"
                    size="sm"
                    side
                    position="top-right"
                    backdrop={false}
                    isOpen={this.state.modal2}
                    toggle={this.toggle(2)}
                  >
                    {/* CABECERA */}
                      <MDBModalHeader className="text-center" titleClass="w-100" tag="p" toggle={this.toggle(2)} >  ADVERTENCIA? </MDBModalHeader>
                    {/* FIN CABECERA */}

                    {/* CUERPO */}
                      <MDBModalBody className="text-center">
                        <MDBIcon icon="times" size="4x" className="animated rotateIn" />
                          {this.state.respuesta.map(select => (
                            <tr key={select.trabajador}>
                              <td>{select.informacion}</td>
                            </tr>
                          ))} 
                      </MDBModalBody>
                    {/* FIN CUERPO */}

                    {/* PIE */}  
                      <MDBModalFooter className="justify-content-center">
                        <MDBBtn color="danger" onClick={this.toggle(2)}>
                          Salir
                        </MDBBtn>
                      </MDBModalFooter>
                    {/* FIN PIE */}  
                  </MDBModal>
                   {/**************************************************************************************/}
                  {/*FIN MODAL DE FRACASO*/}

                </SectionContainer>
            </MDBCol>
          </MDBRow>
        
        </SectionContainer>
      </MDBContainer>
    );
  }
}

export default FormsPage;
